import moment from "moment"
import Vue from "vue"
import api from "@/api" // Importiere die API-Funktionen
export const runWorkoutStore = {
  namespaced: true,
  state: {
    activeSupersetSubIndex: 0, // Zählt, welche Übung im Supersatz dran ist (0, 1, 0, 1, ...)
    exerciseNotesMap: {},
    savedNote: null,
    groupedExercises: [],
    finishedSteps: [],
    workoutStartTime: null,
    activeSplit: null,
    originalActiveSplit: null, // NEU: Eine saubere Kopie des Plans bei Start
    activePlanID: null,
    selectedExerciseIndex: null,
    completedSetsMap: {},
    disabledFeedbackExercises: [],
    workoutModifications: [],
    planInEditMode: {},
    planToClone: null, // NEU: Hält die Kopiervorlage
    // Trainingsplanung
    activeWorkoutPlan: null, // Der aktuell gewählte Plan ({ workout: ..., date: ... })
    // *** NEU: Globale Gewichtsstatistiken ***
    globalWeightStats: {}, // { exerciseId: [weight1, weight2, ...] }
    hubWorkoutPlan: null, // Der Trainingsplan des Nutzers
    hubGroupedSessions: [], // Die letzten 10 Trainings-Sessions
    hubGroupedExercises: [], // Die letzten 10 Übungs-Sessions
    oldWorkoutPlans: [], // Speichert die alten Pläne des Benutzers
    planForConversion: null, // Hält das vorbereitete Objekt für WorkoutCreateNew.vue
    // NEU: Globaler Timer-Status
    timerState: {
      isActive: false,
      startTime: null,
      duration: 0,
      originalDuration: 0,
      isMinimized: false,
      exerciseIndex: null, // Kontext für Restore
      subExerciseId: null, // Kontext für Supersätze
    },
    feedbackEnabled: localStorage.getItem("feedbackEnabled") !== null ? JSON.parse(localStorage.getItem("feedbackEnabled")) : true,
    timerEnabled: localStorage.getItem("timerEnabled") !== null ? JSON.parse(localStorage.getItem("timerEnabled")) : true,
    autoTransitionEnabled: localStorage.getItem("autoTransitionEnabled") !== null ? JSON.parse(localStorage.getItem("autoTransitionEnabled")) : false,
    progressiveOverloadCoachEnabled:
      localStorage.getItem("progressiveOverloadCoachEnabled") !== null ? JSON.parse(localStorage.getItem("progressiveOverloadCoachEnabled")) : true,
    settingsOnboardingShown: JSON.parse(localStorage.getItem("settingsOnboardingShown")) || false, // Persistenz
  },
  mutations: {
    SET_SETTINGS_ONBOARDING_SHOWN(state, value) {
      state.settingsOnboardingShown = value
      localStorage.setItem("settingsOnboardingShown", JSON.stringify(value))
    },
    START_TIMER(state, { duration, startTime = Date.now(), exerciseIndex = null, subExerciseId = null }) {
      state.timerState.isActive = true
      state.timerState.duration = duration
      state.timerState.originalDuration = duration
      state.timerState.startTime = startTime
      state.timerState.isMinimized = false
      state.timerState.exerciseIndex = exerciseIndex
      state.timerState.subExerciseId = subExerciseId
    },
    STOP_TIMER(state) {
      state.timerState.isActive = false
      state.timerState.startTime = null
      state.timerState.duration = 0
      state.timerState.isMinimized = false
      state.timerState.exerciseIndex = null
      state.timerState.subExerciseId = null
    },
    MINIMIZE_TIMER(state) {
      state.timerState.isMinimized = true
    },
    MAXIMIZE_TIMER(state) {
      state.timerState.isMinimized = false
    },
    SET_FEEDBACK_ENABLED(state, value) {
      state.feedbackEnabled = value
      localStorage.setItem("feedbackEnabled", JSON.stringify(value))
    },
    SET_TIMER_ENABLED(state, value) {
      state.timerEnabled = value
      localStorage.setItem("timerEnabled", JSON.stringify(value))
    },
    SET_AUTO_TRANSITION_ENABLED(state, value) {
      state.autoTransitionEnabled = value
      localStorage.setItem("autoTransitionEnabled", JSON.stringify(value))
    },
    SET_PROGRESSIVE_OVERLOAD_COACH_ENABLED(state, value) {
      state.progressiveOverloadCoachEnabled = value
      localStorage.setItem("progressiveOverloadCoachEnabled", JSON.stringify(value))
    },
    MERGE_HUB_DATA(state, { workout, newSessions, newExercises, isDelta }) {
      // Den Trainingsplan selbst aktualisieren wir immer komplett (Meta-Daten)
      if (workout) state.hubWorkoutPlan = workout

      if (!isDelta) {
        // Full Sync (Erstes Laden oder Reset): Einfach alles setzen
        state.hubGroupedSessions = newSessions
        state.hubGroupedExercises = newExercises
      } else {
        // DELTA SYNC: Daten zusammenfügen

        // A) Sessions mergen (Neue Sessions kommen oben drauf)
        // Wir filtern Duplikate, falls sich Zeitfenster überschnitten haben
        const existingSessionIds = new Set(state.hubGroupedSessions.map((s) => s.execution?._id)) // uniqueId wäre ideal, sonst timestamp
        const uniqueNewSessions = newSessions.filter((s) => !existingSessionIds.has(s.execution._id))

        state.hubGroupedSessions = [...uniqueNewSessions, ...state.hubGroupedSessions]

        // B) Exercises mergen (Das ist etwas komplexer)
        // Wir müssen durch die neuen Übungen loopen und schauen, ob wir die Übung schon kennen.
        newExercises.forEach((newEx) => {
          // Robuster ID-Vergleich (fängt String vs. Objekt ab)
          const existingExIndex = state.hubGroupedExercises.findIndex((oldEx) => {
            const oldId = oldEx.exercise && oldEx.exercise._id ? oldEx.exercise._id : oldEx.exercise
            const newId = newEx.exercise && newEx.exercise._id ? newEx.exercise._id : newEx.exercise
            return oldId === newId
          })

          if (existingExIndex !== -1) {
            // === FALL 1: Übung existiert schon -> MERGEN ===
            const oldEx = state.hubGroupedExercises[existingExIndex]

            // ACHTUNG: Hier stand vorher fälschlicherweise 'newExercises[i]'
            // Wir nutzen einfach direkt 'newEx' aus der Schleife.

            // 1. Sets zusammenfügen
            const mergedSets = [...oldEx.sets, ...newEx.sets]
            mergedSets.sort((a, b) => new Date(a.date) - new Date(b.date))

            Vue.set(state.hubGroupedExercises[existingExIndex], "sets", mergedSets)

            // 2. Summary intelligent mergen
            const newSummary = newEx.summary || {}
            const oldSummary = oldEx.summary || {}

            const mergedSummary = {
              totalReps: (oldSummary.totalReps || 0) + (newSummary.totalReps || 0),
              totalWeight: (oldSummary.totalWeight || 0) + (newSummary.totalWeight || 0),
              totalDuration: (oldSummary.totalDuration || 0) + (newSummary.totalDuration || 0),

              maxRepsStep: newSummary.maxRepsStep?.reps > (oldSummary.maxRepsStep?.reps || 0) ? newSummary.maxRepsStep : oldSummary.maxRepsStep,

              maxWeightStep:
                newSummary.maxWeightStep?.weight > (oldSummary.maxWeightStep?.weight || 0) ? newSummary.maxWeightStep : oldSummary.maxWeightStep,

              maxVolumeStep:
                newSummary.maxVolumeStep?.weight * newSummary.maxVolumeStep?.reps >
                (oldSummary.maxVolumeStep?.weight || 0) * (oldSummary.maxVolumeStep?.reps || 0)
                  ? newSummary.maxVolumeStep
                  : oldSummary.maxVolumeStep,
            }

            // NEU: Max Duration berechnen (falls noch nicht vorhanden oder aktualisiert)
            let maxDurationStep = oldSummary.maxDurationStep || { durationSeconds: 0 }

            // Helper zum Parsen der Zeit
            const parseTime = (val) => {
              if (!val) return 0
              if (typeof val === "number") return val
              // Versuche HH:MM:SS oder MM:SS zu parsen
              const parts = val.split(":").map(Number)
              if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2]
              if (parts.length === 2) return parts[0] * 60 + parts[1]
              return parseFloat(val) || 0
            }

            // Check new sets for better duration
            if (newEx.sets) {
              newEx.sets.forEach((set) => {
                if (set.steps) {
                  set.steps.forEach((step) => {
                    console.log(step.time)
                    const dur = parseTime(step.time)
                    if (dur > (maxDurationStep.durationSeconds || 0)) {
                      maxDurationStep = { ...step, durationSeconds: dur, date: set.date }
                    }
                  })
                }
              })
            }
            mergedSummary.maxDurationStep = maxDurationStep

            Vue.set(state.hubGroupedExercises[existingExIndex], "summary", mergedSummary)
          } else {
            // === FALL 2: Übung ist neu ===
            // Auch hier MaxDuration berechnen für die Initialisierung
            const exToAdd = { ...newEx }
            if (!exToAdd.summary) exToAdd.summary = {}

            let maxDurationStep = { durationSeconds: 0 }
            const parseTime = (val) => {
              if (!val) return 0
              if (typeof val === "number") return val
              const parts = val.split(":").map(Number)
              if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2]
              if (parts.length === 2) return parts[0] * 60 + parts[1]
              return parseFloat(val) || 0
            }

            if (exToAdd.sets) {
              exToAdd.sets.forEach((set) => {
                if (set.steps) {
                  set.steps.forEach((step) => {
                    const dur = parseTime(step.time)
                    if (dur > (maxDurationStep.durationSeconds || 0)) {
                      maxDurationStep = { ...step, durationSeconds: dur, date: set.date }
                    }
                  })
                }
              })
            }
            exToAdd.summary.maxDurationStep = maxDurationStep

            state.hubGroupedExercises.push(exToAdd)
          }
        })
      }
    },
    UPDATE_EXERCISE_NOTE(state, { exerciseIndex, note }) {
      Vue.set(state.exerciseNotesMap, exerciseIndex, note)
    },
    SET_PLAN_FOR_CLONING(state, plan) {
      // NEU
      state.planToClone = plan
    },
    RESET_PLAN_FOR_CLONING(state) {
      // NEU
      state.planToClone = null
    },
    // In workoutForGemini/runWorkoutStore.js

    UPDATE_FUTURE_SET_WEIGHTS(state, { exerciseIndex, subExerciseId, startingFromSetIndex, type, value }) {
      const exercise = state.activeSplit.exercises[exerciseIndex]
      if (!exercise) return

      // NEU: Wir bestimmen erst, wo die Sätze liegen (Hauptübung oder Unter-Übung?)
      let targetSets = null

      if (exercise.isSuperset && subExerciseId) {
        // Suche die spezifische Unter-Übung im Supersatz
        const subEx = exercise.exercises.find((e) => e._id === subExerciseId)
        if (subEx && subEx.sets) {
          targetSets = subEx.sets
        }
      } else if (exercise.sets) {
        // Normale Übung
        targetSets = exercise.sets
      }

      if (!targetSets) return

      // Ab hier ist die Logik gleich, aber wir arbeiten auf dem korrekten targetSets Array
      for (let i = startingFromSetIndex; i < targetSets.length; i++) {
        const set = targetSets[i]
        const weightSettingIndex = set.findIndex((s) => s.text === "Gewicht")

        if (weightSettingIndex !== -1) {
          if (type === "absolute") {
            set[weightSettingIndex].value = value
          } else if (type === "relative") {
            const currentWeight = set[weightSettingIndex].value
            const newWeight = Math.max(0, Number(currentWeight) + Number(value))
            set[weightSettingIndex].value = newWeight
          }
        }
      }
    },
    SET_PLAN_IN_EDIT_MODE(state, plan) {
      state.planInEditMode = plan
    },
    SET_ACTIVE_SUPERSET_SUB_INDEX(state, index) {
      state.activeSupersetSubIndex = index
    },
    setActivePlanID(state, planId) {
      state.activePlanID = planId
    },
    setGroupedExercises(state, value) {
      state.groupedExercises = value
    },
    setSelectedExerciseIndex(state, value) {
      state.selectedExerciseIndex = value
    },
    setSavedNote(state, value) {
      state.savedNote = value
    },
    // MODIFIZIERT: Speichert jetzt auch die Originalversion
    setActiveSplit(state, value) {
      const splitCopy = JSON.parse(JSON.stringify(value))
      state.activeSplit = splitCopy
      state.originalActiveSplit = splitCopy // Saubere Kopie für später sichern
    },
    resetWorkoutStartTime(state) {
      state.workoutStartTime = moment().format()
    },
    ADD_COMPLETED_SET(state, { idx, set }) {
      // Hole das bisherige Array oder ein leeres, falls es nicht existiert
      const currentSets = state.completedSetsMap[idx] || []

      // Erstelle ein komplett neues Array mit dem neuen Satz am Ende
      const newSets = [...currentSets, set]

      // Setze das neue Array mit Vue.set, um die Reaktivität sicherzustellen
      Vue.set(state.completedSetsMap, idx, newSets)
    },
    REMOVE_COMPLETED_SET(state, { idx, setPos }) {
      const arr = state.completedSetsMap[idx]
      if (arr && arr.length > setPos) {
        arr.splice(setPos, 1)
      }
    },
    REPLACE_COMPLETED_SET(state, { idx, setPos, newSet }) {
      const arr = state.completedSetsMap[idx]
      if (arr && arr.length > setPos) {
        Vue.set(arr, setPos, newSet)
      }
    },
    UPDATE_COMPLETED_SET(state, { exerciseIndex, setIndex, updatedSet }) {
      const sets = state.completedSetsMap[exerciseIndex]
      if (sets && sets[setIndex]) {
        Vue.set(state.completedSetsMap[exerciseIndex], setIndex, updatedSet)
      }
    },
    CLEAR_COMPLETED_SETS(state, { idx }) {
      Vue.set(state.completedSetsMap, idx, [])
    },
    ADD_DISABLED_FEEDBACK_EXERCISE(state, exerciseId) {
      if (!state.disabledFeedbackExercises.includes(exerciseId)) {
        state.disabledFeedbackExercises.push(exerciseId)
      }
    },
    SWAP_EXERCISE_TEMPORARILY(state, { exerciseIndex, newExercise }) {
      const oldExercise = state.activeSplit.exercises[exerciseIndex]
      this.commit("runWorkoutStore/LOG_WORKOUT_MODIFICATION", {
        type: "swap",
        payload: {
          originalExercise: oldExercise,
          newExercise: newExercise,
          exerciseIndex: exerciseIndex,
        },
      })
      Vue.set(state.activeSplit.exercises, exerciseIndex, newExercise)
      Vue.set(state.completedSetsMap, exerciseIndex, [])
    },
    // NEU: Update einer Übung (ohne Reset der Sets, falls gewünscht - aber hier ersetzen wir meist komplett)
    UPDATE_EXERCISE_IN_SPLIT(state, { exerciseIndex, newExercise }) {
      Vue.set(state.activeSplit.exercises, exerciseIndex, newExercise)
      // Wir resetten hier NICHT die completedSetsMap, da der User vllt. nur den Namen oder ein Ziel ändert.
      // Falls sich die Struktur fundamental ändert (z.B. Supersatz -> Einzel), müsste man aufpassen.
      // Für den Moment gehen wir davon aus, dass der User weiss, was er tut.
    },
    // NEU: Bewegen einer Übung
    MOVE_EXERCISE(state, { fromIndex, toIndex }) {
      const exercises = state.activeSplit.exercises
      if (toIndex < 0 || toIndex >= exercises.length) return

      // 1. Übungen tauschen/verschieben
      const itemToMove = exercises[fromIndex]
      exercises.splice(fromIndex, 1)
      exercises.splice(toIndex, 0, itemToMove)

      // 2. CompletedSetsMap anpassen! Das ist tricky.
      // Wir müssen die Keys in der Map entsprechend verschieben.
      const newMap = {}
      Object.keys(state.completedSetsMap).forEach((key) => {
        const idx = parseInt(key)
        let newIdx = idx
        if (idx === fromIndex) {
          newIdx = toIndex
        } else if (fromIndex < toIndex) {
          // Bewegung nach unten: Alles dazwischen rutscht nach oben (-1)
          if (idx > fromIndex && idx <= toIndex) newIdx = idx - 1
        } else if (fromIndex > toIndex) {
          // Bewegung nach oben: Alles dazwischen rutscht nach unten (+1)
          if (idx >= toIndex && idx < fromIndex) newIdx = idx + 1
        }
        newMap[newIdx] = state.completedSetsMap[idx]
      })
      state.completedSetsMap = newMap
      // Force Reactivity falls nötig (bei kompletter Ersetzung meist automatisch durch Vue)
    },
    ADD_EXERCISE_TEMPORARILY(state, { newExercise, atIndex }) {
      state.activeSplit.exercises.splice(atIndex, 0, newExercise)
      const setsKeys = Object.keys(state.completedSetsMap)
        .map(Number)
        .sort((a, b) => b - a)
      for (const key of setsKeys) {
        if (key >= atIndex) {
          Vue.set(state.completedSetsMap, key + 1, state.completedSetsMap[key])
          Vue.delete(state.completedSetsMap, key)
        }
      }
    },
    REMOVE_EXERCISE_TEMPORARILY(state, exerciseIndex) {
      const removedExercise = state.activeSplit.exercises[exerciseIndex]
      if (!removedExercise) return

      // Log the modification for permanent saving
      this.commit("runWorkoutStore/LOG_WORKOUT_MODIFICATION", {
        type: "delete",
        payload: {
          exercise: removedExercise,
          exerciseIndex: exerciseIndex,
        },
      })

      // Remove from exercises array
      state.activeSplit.exercises.splice(exerciseIndex, 1)

      // Adjust completedSetsMap keys
      const setsKeys = Object.keys(state.completedSetsMap)
        .map(Number)
        .sort((a, b) => a - b)

      const newMap = {}
      for (const key of setsKeys) {
        if (key < exerciseIndex) {
          newMap[key] = state.completedSetsMap[key]
        } else if (key > exerciseIndex) {
          newMap[key - 1] = state.completedSetsMap[key]
        }
      }
      state.completedSetsMap = newMap

      // Adjust exerciseNotesMap keys
      const notesKeys = Object.keys(state.exerciseNotesMap)
        .map(Number)
        .sort((a, b) => a - b)

      const newNotesMap = {}
      for (const key of notesKeys) {
        if (key < exerciseIndex) {
          newNotesMap[key] = state.exerciseNotesMap[key]
        } else if (key > exerciseIndex) {
          newNotesMap[key - 1] = state.exerciseNotesMap[key]
        }
      }
      state.exerciseNotesMap = newNotesMap

      // Adjust selectedExerciseIndex if needed
      if (state.selectedExerciseIndex === exerciseIndex) {
        state.selectedExerciseIndex = null
      } else if (state.selectedExerciseIndex > exerciseIndex) {
        state.selectedExerciseIndex--
      }
    },
    LOG_WORKOUT_MODIFICATION(state, modification) {
      state.workoutModifications.push(modification)
    },
    CLEAR_WORKOUT_MODIFICATIONS(state) {
      state.workoutModifications = []
    },
    RESET_WORKOUT_STATE(state) {
      console.log("i mach ims reset :)")
      state.savedNote = null
      state.finishedSteps = []
      state.workoutStartTime = moment().format()
      state.activeSplit = null
      state.exerciseNotesMap = {} // NEU
      state.originalActiveSplit = null // NEU: Auch die saubere Kopie zurücksetzen
      state.selectedExerciseIndex = null
      state.completedSetsMap = {}
      state.disabledFeedbackExercises = []
      state.workoutModifications = []
    },
    SET_HUB_DATA(state, { workout, groupedSessions, groupedExercises }) {
      state.hubWorkoutPlan = workout // Speichere nur die neusten 10 Einträge, um den Store schlank zu halten
      state.hubGroupedSessions = groupedSessions
      state.hubGroupedExercises = groupedExercises
    },
    SET_OLD_WORKOUT_PLANS(state, plans) {
      state.oldWorkoutPlans = plans
    },
    SET_PLAN_FOR_CONVERSION(state, form) {
      state.planForConversion = form
    },
    RESET_PLAN_FOR_CONVERSION(state) {
      state.planForConversion = null
    },
    // *** NEU: Mutation für Globale Gewichtsstatistiken ***
    SET_GLOBAL_WEIGHT_STATS(state, statsMap) {
      state.globalWeightStats = statsMap
    },
  },
  actions: {
    // *** NEU: Action für Globale Gewichtsstatistiken ***
    async fetchGlobalWeightStatistics({ commit }) {
      try {
        // Assuming 'workoutApi' is available in this scope, e.g., imported or defined globally
        // If not, it needs to be passed or imported. For this task, I'll assume it's accessible.
        const response = await api.workoutApi.getGlobalWeightStatistics()
        if (response.data && response.data.weightStatistics) {
          // Konvertiere das Array [{ _id, usedWeights }] in ein Map-Objekt
          // für direkten Zugriff via exerciseId
          const statsMap = {}
          response.data.weightStatistics.forEach((stat) => {
            if (stat._id) {
              statsMap[stat._id] = stat.usedWeights || []
            }
          })
          commit("SET_GLOBAL_WEIGHT_STATS", statsMap)
        }
      } catch (error) {
        console.error("Fehler beim Laden der globalen Gewichtsstatistiken:", error)
      }
    },
    updateExerciseNote({ commit }, payload) {
      commit("UPDATE_EXERCISE_NOTE", payload)
    },
    setPlanForCloning({ commit }, plan) {
      // NEU
      commit("SET_PLAN_FOR_CLONING", plan)
    },
    resetPlanForCloning({ commit }) {
      // NEU
      commit("RESET_PLAN_FOR_CLONING")
    },
    async checkForPersonalRecord({ state }, { exercise, completedSet }) {
      // Bestimmt die korrekte Übung (wichtig für Supersätze)
      let targetExercise = exercise
      const subExerciseId = completedSet.subExerciseId
      if (exercise.isSuperset && subExerciseId) {
        targetExercise = exercise.exercises.find((e) => e._id === subExerciseId)
      }
      if (!targetExercise) return { isNewRecord: false }

      // 1. Aktuelle Leistung extrahieren und sicherstellen, dass es Zahlen sind
      const currentWeight = Number(completedSet.find((item) => item.text === "Gewicht")?.value || 0)
      const currentReps = Number(completedSet.find((item) => /Wiederholungen/.test(item.text))?.value || 0)
      const currentDistance = Number(completedSet.find((item) => item.text === "Distanz")?.value || 0)
      const currentVolume = currentWeight * currentReps

      // Wenn keine nennenswerte Leistung erbracht wurde, abbrechen
      if (currentWeight === 0 && currentReps === 0 && currentDistance === 0) {
        return { isNewRecord: false }
      }

      // 2. Bisherige Bestleistungen INNERHALB DIESER SESSION finden
      const exerciseIndex = state.activeSplit.exercises.findIndex((ex) => ex._id === exercise._id)
      const allSetsInSessionForThisSlot = state.completedSetsMap[exerciseIndex] || []
      const relevantSets = exercise.isSuperset
        ? allSetsInSessionForThisSlot.filter((set) => set.subExerciseId === subExerciseId)
        : allSetsInSessionForThisSlot

      let sessionMaxWeight = 0
      let sessionMaxVolume = 0
      let sessionMaxDistance = 0
      let sessionMaxReps = 0 // Für reine Rep-Übungen

      relevantSets.slice(0, -1).forEach((set) => {
        // Den aktuellen Satz ausschliessen
        if (set.skipped) return
        const weight = Number(set.find((item) => item.text === "Gewicht")?.value || 0)
        const reps = Number(set.find((item) => /Wiederholungen/.test(item.text))?.value || 0)
        const distance = Number(set.find((item) => item.text === "Distanz")?.value || 0)

        if (weight > sessionMaxWeight) sessionMaxWeight = weight
        if (weight * reps > sessionMaxVolume) sessionMaxVolume = weight * reps
        if (distance > sessionMaxDistance) sessionMaxDistance = distance
        if (reps > sessionMaxReps) sessionMaxReps = reps
      })

      // 3. Historische Rekorde finden
      const historicalData = state.hubGroupedExercises.find((ex) => ex.exercise && ex.exercise._id === targetExercise._id)
      if (!historicalData) {
        return { isNewRecord: false }
      }
      const oldMaxWeight = Number(historicalData?.summary?.maxWeightStep?.weight || 0)
      const oldMaxVolume = Number((historicalData?.summary?.maxVolumeStep?.weight || 0) * (historicalData?.summary?.maxVolumeStep?.reps || 0))
      const oldMaxDistance = Number(historicalData?.summary?.maxDistanceStep?.distance || 0) // NEU
      const oldMaxReps = Number(historicalData?.summary?.maxRepsStep?.reps || 0) // NEU

      // 4. Den wahren Rekord zum Schlagen ermitteln (Maximum aus Historie UND Session)
      const recordToBeatWeight = Math.max(oldMaxWeight, sessionMaxWeight)
      const recordToBeatVolume = Math.max(oldMaxVolume, sessionMaxVolume)
      const recordToBeatDistance = Math.max(oldMaxDistance, sessionMaxDistance) // NEU
      const recordToBeatReps = Math.max(oldMaxReps, sessionMaxReps) // NEU

      // 5. Vergleichen - Logik nach Priorität (Distanz > Gewicht > Volumen > Reps)

      // Fall 1: Distanz-Übung
      if (currentDistance > 0 && currentDistance > recordToBeatDistance) {
        return { isNewRecord: true, type: "Weiteste Distanz", oldValue: `${oldMaxDistance} m`, newValue: `${currentDistance} m` }
      }

      // Fall 2: Gewichts-Übung
      if (currentWeight > 0 && currentWeight > recordToBeatWeight) {
        return { isNewRecord: true, type: "Maximalgewicht", oldValue: `${oldMaxWeight} kg`, newValue: `${currentWeight} kg` }
      }
      if (currentVolume > 0 && currentVolume > recordToBeatVolume) {
        return { isNewRecord: true, type: "Maximalvolumen", oldValue: `${oldMaxVolume.toFixed(0)} kg`, newValue: `${currentVolume.toFixed(0)} kg` }
      }

      // Fall 3: Reine Wiederholungs-Übung (kein Gewicht, keine Distanz)
      if (currentWeight === 0 && currentDistance === 0 && currentReps > recordToBeatReps) {
        return { isNewRecord: true, type: "Maximale Wiederholungen", oldValue: `${oldMaxReps} WH`, newValue: `${currentReps} WH` }
      }

      // Kein neuer Rekord
      return { isNewRecord: false }
    },
    async initiateFreeTraining({ commit, dispatch }, freeSplit) {
      await dispatch("resetWorkoutState")

      commit("setActiveSplit", freeSplit)
      if (freeSplit.planID) {
        console.log("setting plan id", freeSplit.planID)
        commit("setActivePlanID", freeSplit.planID)
      }
    },
    async loadOldPlansForUser({ commit }, userId) {
      try {
        const oldPlans = await api.getTrainingPlansForUser(userId) // Annahme: Diese API-Methode existiert
        commit("SET_OLD_WORKOUT_PLANS", oldPlans)
      } catch (error) {
        console.error("Fehler beim Laden der alten Pläne für den Benutzer:", error)
        commit("SET_OLD_WORKOUT_PLANS", [])
      }
    },

    async loadOldPlans({ commit }) {
      // Lädt die alten Pläne (aus dem "workouts" Model)
      try {
        const oldPlans = await api.getTrainingPlans() // Annahme, dass diese API-Methode existiert und die alten Pläne lädt
        commit("SET_OLD_WORKOUT_PLANS", oldPlans)
      } catch (error) {
        console.error("Fehler beim Laden der alten Pläne:", error)
        commit("SET_OLD_WORKOUT_PLANS", []) // Bei Fehler leeres Array setzen
      }
    },
    setPlanForConversion({ commit }, form) {
      commit("SET_PLAN_FOR_CONVERSION", form)
    },
    resetPlanForConversion({ commit }) {
      commit("RESET_PLAN_FOR_CONVERSION")
    },
    setPlanForEditing({ commit }, plan) {
      commit("SET_PLAN_IN_EDIT_MODE", plan)
    },
    updateFutureExerciseWeights({ commit }, payload) {
      commit("UPDATE_FUTURE_SET_WEIGHTS", payload)
    },
    async loadHubData({ commit, state }) {
      try {
        console.log("Lade Hub-Daten...")
        let lastUpdated = 0

        if (state.hubGroupedSessions && state.hubGroupedSessions.length > 0) {
          const newestSession = state.hubGroupedSessions[0]
          lastUpdated = newestSession.execution ? parseInt(newestSession.execution.ts) : 0
        }

        // 2. Zuerst den User-Plan laden (das geht meist schnell)
        let workout = await api.fetchOwnWorkout()
        if (!workout || !workout.splits) workout = null
        const existingSessionsResponse = await api.fetchExistingSessions(lastUpdated)
        console.log("da hani", existingSessionsResponse)
        commit("MERGE_HUB_DATA", {
          workout,
          newSessions: existingSessionsResponse.groupedSessions,
          newExercises: existingSessionsResponse.groupedExercises,
          isDelta: lastUpdated > 0 && existingSessionsResponse.isDelta, // Backend sollte bestätigen, dass es ein Delta war
        })
      } catch (error) {
        console.error("Fehler beim Laden der Hub-Daten:", error)
      }
    },
    setActivePlanID({ commit }, planId) {
      commit("setActivePlanID", planId)
    },
    setSelectedExerciseIndex({ commit, state }, value) {
      commit("setSelectedExerciseIndex", value)
      const exercise = state.activeSplit && state.activeSplit.exercises[value]

      if (exercise && exercise.isSuperset) {
        const completedSets = state.completedSetsMap[value] || []
        const numberOfSubExercises = exercise.exercises.length

        if (numberOfSubExercises > 0) {
          const nextSubIndex = completedSets.length % numberOfSubExercises
          commit("SET_ACTIVE_SUPERSET_SUB_INDEX", nextSubIndex)
        } else {
          commit("SET_ACTIVE_SUPERSET_SUB_INDEX", 0)
        }
      } else {
        commit("SET_ACTIVE_SUPERSET_SUB_INDEX", 0)
      }
    },
    resetWorkoutStartTime({ commit }) {
      commit("resetWorkoutStartTime")
    },
    setActiveSplit({ commit }, value) {
      commit("setActiveSplit", value)
    },
    addCompletedSet({ commit, state, getters }, { set, isWarmup }) {
      // Nimmt jetzt 'isWarmup' entgegen
      const exerciseIndex = state.selectedExerciseIndex
      const mainExercise = getters.getSelectedExercise
      if (exerciseIndex === null || !mainExercise) return

      let setToAdd = [...set]

      // Füge das isWarmup-Flag hinzu, wenn es übergeben wurde
      if (isWarmup) {
        setToAdd.isWarmup = true
      }

      if (mainExercise.isSuperset) {
        const subExercise = getters.getActiveSupersetSubExercise
        setToAdd.subExerciseId = subExercise._id
      }

      commit("ADD_COMPLETED_SET", { idx: exerciseIndex, set: setToAdd })

      if (mainExercise.isSuperset) {
        const newSubIndex = (state.activeSupersetSubIndex + 1) % mainExercise.exercises.length
        commit("SET_ACTIVE_SUPERSET_SUB_INDEX", newSubIndex)
      }
    },

    removeCompletedSet({ commit }, payload) {
      commit("REMOVE_COMPLETED_SET", payload)
    },
    replaceCompletedSet({ commit }, payload) {
      commit("REPLACE_COMPLETED_SET", payload)
    },
    updateCompletedSet({ commit }, payload) {
      commit("UPDATE_COMPLETED_SET", payload)
    },
    clearCompletedSets({ commit }, payload) {
      commit("CLEAR_COMPLETED_SETS", payload)
    },
    setGroupedExercises({ commit }, payload) {
      commit("setGroupedExercises", payload)
    },
    setFeedbackEnabled({ commit }, payload) {
      commit("SET_FEEDBACK_ENABLED", payload)
    },
    addDisabledFeedbackExercise({ commit }, exerciseId) {
      commit("ADD_DISABLED_FEEDBACK_EXERCISE", exerciseId)
    },
    resetWorkoutState({ commit }) {
      commit("RESET_WORKOUT_STATE")
    },

    swapExerciseTemporarily({ commit }, payload) {
      commit("SWAP_EXERCISE_TEMPORARILY", payload)
    },

    addExerciseTemporarily({ commit }, { newExercise, atIndex }) {
      commit("ADD_EXERCISE_TEMPORARILY", { newExercise, atIndex })
      commit("LOG_WORKOUT_MODIFICATION", {
        type: "add",
        payload: {
          newExercise: newExercise,
        },
      })
    },
    updateExerciseInSplit({ commit }, payload) {
      commit("UPDATE_EXERCISE_IN_SPLIT", payload)
    },
    moveExercise({ commit }, payload) {
      commit("MOVE_EXERCISE", payload)
    },
    removeExerciseTemporarily({ commit }, exerciseIndex) {
      commit("REMOVE_EXERCISE_TEMPORARILY", exerciseIndex)
    },
    // Timer Actions
    startTimer({ commit }, payload) {
      commit("START_TIMER", payload)
    },
    stopTimer({ commit }) {
      commit("STOP_TIMER")
    },
    minimizeTimer({ commit }) {
      commit("MINIMIZE_TIMER")
    },
    maximizeTimer({ commit }) {
      commit("MAXIMIZE_TIMER")
    },
    setTimerEnabled({ commit }, value) {
      commit("SET_TIMER_ENABLED", value)
    },
    setAutoTransitionEnabled({ commit }, value) {
      commit("SET_AUTO_TRANSITION_ENABLED", value)
    },
    setProgressiveOverloadCoachEnabled({ commit }, value) {
      commit("SET_PROGRESSIVE_OVERLOAD_COACH_ENABLED", value)
    },
    // GENARIERT VORSCHAU-DATEN (für den Dialog)
    // GENERIERT VORSCHAU-DATEN (für den Dialog) - JETZT MIT EINZELNEN SÄTZEN
    generateAutoCompletionPreview({ state }) {
      if (!state.activeSplit || !state.activeSplit.exercises) return []

      const previewData = []

      // Helper function to parse/sanitize values
      const parseValue = (item) => {
        let val = item.value
        if (typeof val === "string" && val.includes("-")) {
          const parts = val.split("-").map((v) => parseFloat(v.trim()))
          if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
            val = (parts[0] + parts[1]) / 2
          }
        }
        if (["Gewicht", "Wiederholungen", "Distanz", "Dauer"].includes(item.text)) {
          const num = parseFloat(val)
          if (!isNaN(num)) return num
        }
        return val
      }

      state.activeSplit.exercises.forEach((exercise, exIdx) => {
        // --- FALL 1: SUPERSÄTZE ---
        if (exercise.isSuperset) {
          exercise.exercises.forEach((subEx) => {
            const plannedSets = subEx.sets || []
            const currentSets = state.completedSetsMap[exIdx] || []
            const completedForSub = currentSets.filter((s) => s.subExerciseId === subEx._id)
            const missingCount = Math.max(0, plannedSets.length - completedForSub.length)

            const totalSetsToShow = completedForSub.length + missingCount

            if (totalSetsToShow > 0) {
              const allSets = []

              // 1. Bereits absolvierte Sätze hinzufügen (Read-Only)
              completedForSub.forEach((compSet, idx) => {
                let weight = 0
                let reps = 0
                let duration = 0
                let unit = "s"

                const wItem = compSet.find((x) => x.text === "Gewicht")
                if (wItem) weight = parseFloat(wItem.value)

                const rItem = compSet.find((x) => x.text === "Wiederholungen")
                if (rItem) reps = parseFloat(rItem.value)

                const dItem = compSet.find((x) => x.text === "Dauer")
                if (dItem) {
                  duration = parseFloat(dItem.value)
                  if (dItem.unit) unit = dItem.unit
                }

                const isDurationOnly = duration > 0 && weight === 0 && reps === 0

                allSets.push({
                  index: idx + 1,
                  fillWeight: weight,
                  fillReps: reps,
                  fillDuration: duration,
                  durationUnit: unit,
                  isDurationOnly: isDurationOnly,
                  isCompleted: true, // Markiert als erledigt
                  layoutSet: null,
                })
              })

              // 2. Offene Sätze hinzufügen (Editierbar)
              for (let i = 0; i < missingCount; i++) {
                // Hole den EXAKTEN geplanten Satz
                const setIndexToTake = completedForSub.length + i
                const planSet = plannedSets[setIndexToTake] || plannedSets[plannedSets.length - 1] // Fallback

                let weight = 0
                let reps = 0
                let duration = 0
                let unit = "s"

                if (planSet) {
                  const wItem = planSet.find((x) => x.text === "Gewicht")
                  if (wItem) weight = parseValue(wItem)

                  const rItem = planSet.find((x) => x.text === "Wiederholungen" || x.text === "Min Wiederholungen")
                  if (rItem) reps = parseValue(rItem)

                  const dItem = planSet.find((x) => x.text === "Dauer")
                  if (dItem) {
                    duration = parseValue(dItem)
                    if (dItem.unit) unit = dItem.unit
                  }
                }

                // Check ob es sich um eine reine Dauer-Übung handelt
                const isDurationOnly = duration > 0 && weight === 0 && reps === 0

                allSets.push({
                  index: setIndexToTake + 1, // 1-based index für UI
                  fillWeight: weight,
                  fillReps: reps,
                  fillDuration: duration,
                  durationUnit: unit,
                  isDurationOnly: isDurationOnly,
                  isCompleted: false,
                  layoutSet: JSON.parse(JSON.stringify(planSet || {})),
                })
              }

              previewData.push({
                exerciseTitle: subEx.title,
                exerciseIndex: exIdx,
                subExerciseId: subEx._id,
                isSuperset: true,
                sets: allSets,
              })
            }
          })
        }
        // --- FALL 2: NORMALE ÜBUNGEN ---
        else {
          const plannedSets = exercise.sets || []
          const currentSets = state.completedSetsMap[exIdx] || []
          const completedRegular = currentSets.filter((s) => !s.isWarmup)
          const missingCount = Math.max(0, plannedSets.length - completedRegular.length)

          const totalSetsToShow = completedRegular.length + missingCount

          if (totalSetsToShow > 0) {
            const allSets = []

            // 1. Bereits absolvierte Sätze
            completedRegular.forEach((compSet, idx) => {
              let weight = 0
              let reps = 0
              let duration = 0
              let unit = "s"

              const wItem = compSet.find((x) => x.text === "Gewicht")
              if (wItem) weight = parseFloat(wItem.value)

              const rItem = compSet.find((x) => x.text === "Wiederholungen")
              if (rItem) reps = parseFloat(rItem.value)

              const dItem = compSet.find((x) => x.text === "Dauer")
              if (dItem) {
                duration = parseFloat(dItem.value)
                if (dItem.unit) unit = dItem.unit
              }

              const isDurationOnly = duration > 0 && weight === 0 && reps === 0

              allSets.push({
                index: idx + 1,
                fillWeight: weight,
                fillReps: reps,
                fillDuration: duration,
                durationUnit: unit,
                isDurationOnly: isDurationOnly,
                isCompleted: true,
                layoutSet: null,
              })
            })

            // 2. Offene Sätze
            for (let i = 0; i < missingCount; i++) {
              const setIndexToTake = completedRegular.length + i
              const planSet = plannedSets[setIndexToTake] || plannedSets[plannedSets.length - 1]

              let weight = 0
              let reps = 0
              let duration = 0
              let unit = "s"

              if (planSet) {
                const wItem = planSet.find((x) => x.text === "Gewicht")
                if (wItem) weight = parseValue(wItem)

                const rItem = planSet.find((x) => x.text === "Wiederholungen" || x.text === "Min Wiederholungen")
                if (rItem) reps = parseValue(rItem)

                const dItem = planSet.find((x) => x.text === "Dauer")
                if (dItem) {
                  duration = parseValue(dItem)
                  if (dItem.unit) unit = dItem.unit
                }
              }

              const isDurationOnly = duration > 0 && weight === 0 && reps === 0

              allSets.push({
                index: setIndexToTake + 1,
                fillWeight: weight,
                fillReps: reps,
                fillDuration: duration,
                durationUnit: unit,
                isDurationOnly: isDurationOnly,
                isCompleted: false,
                layoutSet: JSON.parse(JSON.stringify(planSet || {})),
              })
            }

            previewData.push({
              exerciseTitle: exercise.title,
              exerciseIndex: exIdx,
              subExerciseId: null,
              isSuperset: false,
              sets: allSets,
            })
          }
        }
      })
      return previewData
    },

    // WENDET DIE (GGF. EDITIERTEN) DATEN AN
    applyAutoCompletion({ commit }, previewData) {
      previewData.forEach((exerciseItem) => {
        if (exerciseItem.sets) {
          exerciseItem.sets.forEach((setItem) => {
            // Bereits erledigte Sätze überspringen!
            if (setItem.isCompleted) return

            const setClone = JSON.parse(JSON.stringify(setItem.layoutSet))

            // Update Werte basierend auf User-Edit (oder Defaults)
            const wItem = setClone.find((x) => x.text === "Gewicht")
            if (wItem) wItem.value = parseFloat(setItem.fillWeight)

            const rItem = setClone.find((x) => x.text === "Wiederholungen" || x.text === "Min Wiederholungen")
            if (rItem) {
              rItem.text = "Wiederholungen" // Normalize
              rItem.value = parseFloat(setItem.fillReps)
            }

            // NEU: Update Dauer + Einheit
            const dItem = setClone.find((x) => x.text === "Dauer")
            if (dItem) {
              dItem.value = parseFloat(setItem.fillDuration)
              if (setItem.durationUnit) dItem.unit = setItem.durationUnit
            }

            if (exerciseItem.subExerciseId) {
              setClone.subExerciseId = exerciseItem.subExerciseId
            }

            commit("ADD_COMPLETED_SET", { idx: exerciseItem.exerciseIndex, set: setClone })
          })
        }
      })
    },
  },
  getters: {
    // Timer Getters
    isGlobalTimerActive: (state) => state.timerState.isActive,
    timerState: (state) => state.timerState,
    getExerciseNote: (state) => (exerciseIndex) => state.exerciseNotesMap[exerciseIndex],
    getActiveSupersetSubExercise: (state, getters) => {
      const mainExercise = getters.getSelectedExercise
      if (!mainExercise || !mainExercise.isSuperset) {
        return null
      }
      return mainExercise.exercises[state.activeSupersetSubIndex]
    },
    // In runWorkoutStore.js -> getters
    // In runWorkoutStore.js -> getters
    getCurrentSatzVorgaben: (state, getters) => {
      const mainExercise = getters.getSelectedExercise
      if (!mainExercise) return []

      if (mainExercise.isSuperset) {
        const subExercise = getters.getActiveSupersetSubExercise
        if (!subExercise || !subExercise.sets || subExercise.sets.length === 0) return []

        const completedSetsForSub = (state.completedSetsMap[state.selectedExerciseIndex] || []).filter(
          (set) => set.subExerciseId === subExercise._id && !set.skipped,
        ).length

        // Gibt die Vorgabe für den nächsten Satz oder die letzte verfügbare Vorgabe zurück
        return subExercise.sets[completedSetsForSub] || subExercise.sets[subExercise.sets.length - 1] || []
      }

      // *** START DER NEUEN, ROBUSTEN LOGIK FÜR EINZELÜBUNGEN ***
      else {
        const completedSets = state.completedSetsMap[state.selectedExerciseIndex] || []
        const hasWarmupDefined = mainExercise.warmup && mainExercise.warmup.length > 0

        // Fall 1: Die Übung hat kein Warmup.
        if (!hasWarmupDefined) {
          const regularSetsCompleted = completedSets.filter((set) => !set.skipped).length
          return mainExercise.sets[regularSetsCompleted] || mainExercise.sets[mainExercise.sets.length - 1] || []
        }

        // Fall 2: Die Übung HAT ein Warmup.
        else {
          const hasCompletedASet = completedSets.length > 0
          const firstSetWasSkipped = hasCompletedASet && completedSets[0].skipped

          // Bedingung, um die Warmup-Vorgaben zu zeigen:
          // Entweder wurde noch gar kein Satz gemacht, ODER der erste und einzige Satz wurde übersprungen.
          const showWarmupSettings = !hasCompletedASet || (completedSets.length === 1 && firstSetWasSkipped)

          if (showWarmupSettings) {
            return mainExercise.warmup
          }
          // Andernfalls sind wir definitiv bei den regulären Sätzen.
          else {
            // Zähle nur die Sätze, die nach dem Warmup kamen und nicht übersprungen wurden.
            const regularSetsCompleted = completedSets.filter((set) => !set.isWarmup && !set.skipped).length
            return mainExercise.sets[regularSetsCompleted] || mainExercise.sets[mainExercise.sets.length - 1] || []
          }
        }
      }
    },
    getSelectedExercise(state) {
      if (state.selectedExerciseIndex !== null && state.activeSplit) {
        return state.activeSplit.exercises[state.selectedExerciseIndex]
      }
      return null
    },
    getCompletedSets: (state) => (idx) => {
      return state.completedSetsMap[idx] || []
    },
    isFeedbackDisabledForExercise: (state) => (exerciseId) => {
      return state.disabledFeedbackExercises.includes(exerciseId)
    },
    getWorkoutModifications(state) {
      return state.workoutModifications
    },
    hubWorkoutPlan: (state) => state.hubWorkoutPlan,
    hubGroupedSessions: (state) => state.hubGroupedSessions,
    hubGroupedExercises: (state) => state.hubGroupedExercises,
    oldWorkoutPlans: (state) => state.oldWorkoutPlans,
    planForConversion: (state) => state.planForConversion,
    planToClone: (state) => state.planToClone, // NEU
    feedbackEnabled: (state) => state.feedbackEnabled,
    timerEnabled: (state) => state.timerEnabled,
    autoTransitionEnabled: (state) => state.autoTransitionEnabled,
    progressiveOverloadCoachEnabled: (state) => state.progressiveOverloadCoachEnabled,
    settingsOnboardingShown: (state) => state.settingsOnboardingShown,
  },
}
